import React, { useEffect, useState, useRef } from 'react'
import OttDesktopLayout from './ott_desktop_layout'
import OttMobileLayout from './ott_mobile_layout'
import OttHeader from './ott_header'
import OttTitle from './ott_title'
import OttFooter from './ott_footer'
import OttRefreshStatusBar from './ott_refresh_status_bar'
import { createPortal } from 'react-dom'
import { useSelector, useDispatch } from 'react-redux'
import OttScreen from '../ott_screen'
import { refreshAfterCancel } from '../actions'


const OttLayout = () => {
  const dispatch = useDispatch()
  const [ isMobile, setIsMobile ] = useState(window.innerWidth <= 800)
  const headerRef = useRef(null)
  const state = useSelector(state => state)
  const leagueId = useSelector(state => state.leagueId)
  const roundId = useSelector(state => state.roundId)
  const [ mobileHeaderHeightOffset, setMobileHeaderHeightOffset ] = useState(0) // eslint-disable-line no-unused-vars
  const isAdminMode = useSelector(state => state.isAdminMode)
  const activeScreen = useSelector(state => state.activeScreen)
  const firstAvailableFoursome = useSelector(state=> state.firstAvailableFoursome)
  const waitlistEnabled = useSelector(state => state.waitlistEnabled)
  const pendingRegEnabled = useSelector(state => state.pendingRegEnabled)
  const invitationEnabled = useSelector(state => state.invitationEnabled)
  const bookBeforeRegister = useSelector(state => state.bookBeforeRegister)
  const currentMemberId = useSelector(state => state.currentMemberId)
  const addedToWaitlist = useSelector(state=> state.addedToWaitlist)

  useEffect(() => {
    if (!isMobile) {
      const bannerElement = window.parent?.document?.querySelector('.banner')
      const bannerWidth = bannerElement ? bannerElement.getBoundingClientRect().height : 0
      window.parent.scrollTo({top: bannerWidth})
    }
  }, [ state ])

  useEffect(() => {
    dispatch(refreshAfterCancel(leagueId, roundId, currentMemberId))
  }, [])

  useEffect(() => {
    const websiteContainer = window.parent.document.querySelector('body.website.container')

    const cleanUpBeforeLeavingOttPage = () => {
      const ottHeaderWrapper = window.parent.document.getElementById('ott-header-wrapper')
      if (ottHeaderWrapper) {
        ottHeaderWrapper.remove()
      }
      
      const ottMobileFooter = window.parent.document.querySelector('.ott-mobile-footer')
      if (ottMobileFooter) {
        ottMobileFooter.remove()
      }

      // Reset overflow before leaving the page
      if (websiteContainer) {
        websiteContainer.style.overflow = ''
      }

      const bannerElement = window.parent?.document?.querySelector('.banner')
      const bannerWidth = bannerElement ? bannerElement.getBoundingClientRect().height : 0

      if( isMobile && bannerWidth > 0) {
        window.parent.scrollTo({top: bannerWidth})
      }
    }

    if (isMobile) {
      window.scrollTo({top: 285* firstAvailableFoursome})
      const headerWrapperDiv = document.createElement('div')
      headerWrapperDiv.id = 'ott-header-wrapper'
      window.parent.document.getElementById('main_content').prepend(headerWrapperDiv)

      if (websiteContainer) {
        websiteContainer.style.overflow = 'hidden'
      }
  
      window.addEventListener('visibilitychange', cleanUpBeforeLeavingOttPage)
    }

    // Observe header height changes and adjust the mobile layout offset accordingly
    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        if (entry.target === headerRef.current) {
          setMobileHeaderHeightOffset(entry.contentRect.height)
        }
      }
    })
    

    if (headerRef.current) {
      resizeObserver.observe(headerRef.current)
    }


    // Observe window resize and display the desktop/mobile layout accordingly
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 800)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      // if (headerRef.current) { resizeObserver.unobserve(headerRef.current) }
      window.removeEventListener('resize', handleResize)
      
      if (isMobile) {
        cleanUpBeforeLeavingOttPage()
      }
    }
  }, [ isMobile ])

  return (
    <body className="ott-v2">
      <div className="ott-page-root">
        {isMobile
          ?
          <>
            {/* <OttTitle/> */}
            {isAdminMode
              ?
                <section className="ott-mobile-header margin-bottom-20-px height-auto" ref={headerRef}>
                  <OttHeader/>
                </section>
              :
              <>
              {
                activeScreen === OttScreen.CREATE_BOOKING && currentMemberId.length == 0 && bookBeforeRegister === false
                ?
                <></>
                :
                createPortal(
                <section className="ott-mobile-header" ref={headerRef}>
                  <OttHeader/>
                </section>
              , window.parent.document.getElementById('main_content').firstElementChild)
              }
              </>
            }

            <section className="ott-mobile-layout">
              <OttMobileLayout/>
            </section>
            
            {createPortal(
              <section className="ott-mobile-footer">
                <OttFooter/>
              </section>
              , window.parent.document.getElementById('main_content'))}
          </>
          :
          <>
            {activeScreen === OttScreen.CREATE_BOOKING && waitlistEnabled === false && pendingRegEnabled === false && invitationEnabled === false && addedToWaitlist === false ? 
              <div className="desktop-header-container">
                <OttTitle/>
                <OttHeader/>
              </div>
              :
              <>
              <OttTitle/>
              <OttHeader/>
              </>
            }
            <OttDesktopLayout/>
            <OttFooter/>
            {createPortal(<OttRefreshStatusBar/>, window.parent.document.getElementById('main_content'))}
          </>
        }
      </div>
    </body>
  )
}

export default OttLayout
